// extracted by mini-css-extract-plugin
module.exports = {"layout":"ai9_u1","covidLinkWrapper":"ai9_aja","covidLink":"ai9_ajb","text":"ai9_jv","underlineText":"ai9_ajc","closeIcon":"ai9_w6"};